import React from "react";
import { useSelector } from 'react-redux';
import { Text } from "../theme/theme";
import BlockContent from '@sanity/block-content-to-react'

const Footer = ()=>{
    

    
        return <div style={{textAlign: "center", marginLeft: "20vw", marginRight: "20vw", marginTop: "50px"}}>
        <i>
            <Text> Made with ♥ by <a href="http://pietersteyaert.net">Pieter Steyaert</a> with  Oriel Marshall, Marrick Braam, Thorsten Balduin and Jesper Bruun as part of <a href="https://chameleon.iwf.oeaw.ac.at/">CHAMELEON</a> </Text>
            
        </i>
    </div>
    

    
}

export default Footer;